module.exports = __webpack_public_path__ + "static/media/T21.2c261104.png";